import React from 'react';
import { getSafeValue } from "../../helpers/helper";

export default function Button({
    children,
    onClick,
    color = "blue",
    disabled = false,
    size = "medium",
}) {

    const colorClasses = {
        blue: "bg-blue-500 hover:bg-blue-700 text-white",
        red: "bg-red-600 hover:bg-red-700 text-white",
        green: "bg-green-600 hover:bg-green-700 text-white",
        gray: "bg-gray-500 hover:bg-gray-700 text-white",
        yellow: "bg-yellow-500 hover:bg-yellow-700 text-white",
        lightGray: "bg-[#f3f4f6] hover:bg-[#e5e7eb] text-[#4b5563] border border-[#d1d5db]",
      };

    const sizeClasses = {
        small: "px-3 py-1.5 text-sm",
        medium: "px-4 py-2 text-base",
        large: "px-6 py-3 text-lg",
    };

    const colorClass = getSafeValue(colorClasses, color, "blue");
    const sizeClass = getSafeValue(sizeClasses, size, "medium");

    const baseClasses = `
        inline-flex items-center justify-center gap-2
        ${disabled ? "" : colorClass}
        ${sizeClass}
        ${disabled ? 'bg-gray-400 hover:bg-gray-400 cursor-not-allowed text-gray-200' : ""}
        rounded-md
        font-semibold
        transition-all duration-200
      `;

    return (
        <button
          onClick={onClick}
          disabled={disabled}
          className={baseClasses}
        >
            {children}
        </button>
    );
};
